import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDLxBQhOALRfERURaDkBTmSyMayeb_MgtA",
  authDomain: "expens-trackr.firebaseapp.com",
  projectId: "expens-trackr",
  storageBucket: "expens-trackr.appspot.com",
  messagingSenderId: "85373472351",
  appId: "1:85373472351:web:289b29d8624cbfd69a15ea",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const dbFirebase = firebaseApp.firestore();

export default dbFirebase;
